/** Observe rendered, visible content once; hidden tabs and off-screen banners do not count. */
export function observeBiteScreen(element: HTMLElement, onVisible: () => void) {
  let visible = false, delivered = false;
  const publish = () => {
    if (visible && !document.hidden && !delivered) { delivered = true; onVisible(); }
  };
  const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; publish(); }, {threshold: 0.01});
  observer.observe(element);
  document.addEventListener('visibilitychange', publish);
  return () => { observer.disconnect(); document.removeEventListener('visibilitychange', publish); };
}
